<template>
  <div @click.stop="toggleActivity" class="pointer">
    <svg :width="svgWnH ? svgWnH : 46" :height="svgWnH ? svgWnH : 46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" 
      :id='"Component_8_1" + content.objectid'
      :class='"Component_8_1"'
      v-if="!liked"
    >
      <circle cx="23" cy="23" r="22" stroke="#969696" stroke-width="2"/>
      <path d="M15.7362 31.6364C15.5968 31.6364 15.4574 31.6364 15.318 31.6441C14.5222 31.708 13.99 31.1938 14.0001 30.3879C14.0306 28.1186 14.0559 25.8493 14.0838 23.5826C14.099 22.4415 14.393 22.1524 15.5259 22.1524C16.4991 22.1524 17.4698 22.1601 18.443 22.1422C18.5647 22.1422 18.7091 22.0143 18.7978 21.9068C19.1197 21.5205 19.4238 21.1214 19.733 20.7223C21.0256 19.0516 22.0292 17.2326 22.5792 15.1757C22.7211 14.641 22.8377 14.0986 22.967 13.5588C23.0379 13.262 23.3497 13.0087 23.6513 13.001C25.1719 12.9601 26.4569 14.137 26.3428 15.7206C26.2567 16.9231 25.8613 18.1025 25.6028 19.2921C25.6028 19.2921 25.6028 19.2972 25.6028 19.2998C25.5267 19.6401 25.8157 19.9471 26.1578 19.8908C26.2896 19.8703 26.4214 19.855 26.5506 19.8524C27.6531 19.8345 28.7632 19.7654 29.853 19.8882C30.9783 20.0162 31.5156 20.8758 31.7386 21.9401C32.1213 23.7668 32.096 25.5883 31.5815 27.3792C31.2926 28.3872 31.0036 29.4234 30.5221 30.3418C29.9164 31.4931 28.71 32.015 27.5264 31.9997C26.3504 31.9843 25.1745 31.9383 23.9985 31.8794C22.8225 31.818 21.6465 31.7438 20.4731 31.6748C20.1031 31.6517 19.733 31.6313 19.363 31.6082L18.3568 31.6492M19.4973 30.1269C19.4973 30.3879 19.7001 30.6028 19.9586 30.6181C20.3894 30.6412 20.7874 30.6616 21.1878 30.6744C23.2432 30.7333 25.3012 30.874 27.3515 30.8049C28.6314 30.7614 29.8758 30.2088 29.6908 28.5126C29.6756 28.3821 29.8125 28.2056 29.924 28.0981C30.5018 27.5404 30.659 26.8854 30.4613 26.1102C30.4207 25.9465 30.4334 25.7163 30.5196 25.5807C30.9884 24.8464 31.0189 24.1403 30.5398 23.3907C30.4309 23.2218 30.4182 22.9097 30.4917 22.7127C30.8465 21.7354 30.5348 21.0242 29.5159 20.9832C28.2436 20.9321 26.9562 21.0293 25.6889 21.1879C24.6676 21.3158 24.3254 21.1009 24.4116 20.0034C24.5054 18.7984 24.9058 17.6215 25.1567 16.4293C25.3062 15.7155 25.3519 14.9991 24.7056 14.4849C24.5206 14.3391 24.3609 14.2112 24.1404 14.3263C23.9478 14.4261 23.8084 15.145 23.7704 15.2754C23.114 17.6394 22.0495 19.8038 20.4731 21.6714C19.7888 22.4799 19.4289 23.273 19.4745 24.3654C19.5531 26.274 19.5075 28.1902 19.4999 30.132L19.4973 30.1269ZM18.2402 30.2165V23.7744C18.2402 23.5032 18.0223 23.2858 17.7562 23.2858H15.4296C15.1609 23.2858 14.9455 23.5058 14.9455 23.7744V30.2165C14.9455 30.4877 15.1634 30.7051 15.4296 30.7051H17.7562C18.0248 30.7051 18.2402 30.4851 18.2402 30.2165Z" 
      :fill="liked ? likedColor : noColor"
      />
    </svg>     
    <svg :width="svgWnH ? svgWnH : 46" :height="svgWnH ? svgWnH : 46" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21 42.5625C32.598 42.5625 42 33.1605 42 21.5625C42 9.96452 32.598 0.5625 21 0.5625C9.40202 0.5625 0 9.96452 0 21.5625C0 33.1605 9.40202 42.5625 21 42.5625ZM13.318 31.2066C13.4574 31.1989 13.5968 31.1989 13.7362 31.1989L16.3568 31.2117L17.363 31.1707C17.548 31.1823 17.733 31.1931 17.918 31.204C18.1031 31.2149 18.2881 31.2257 18.4731 31.2373C18.8012 31.2566 19.1296 31.2763 19.4581 31.296C20.3042 31.3468 21.1514 31.3977 21.9985 31.4419C23.1745 31.5008 24.3504 31.5468 25.5264 31.5622C26.71 31.5775 27.9164 31.0556 28.5221 29.9043C28.9871 29.0174 29.2725 28.0208 29.5517 27.0458C29.5616 27.011 29.5716 26.9764 29.5815 26.9417C30.096 25.1508 30.1213 23.3293 29.7386 21.5026C29.5156 20.4383 28.9783 19.5787 27.853 19.4507C26.9924 19.3538 26.1192 19.3764 25.2471 19.3991C25.0148 19.4051 24.7825 19.4111 24.5506 19.4149C24.4214 19.4175 24.2896 19.4328 24.1578 19.4533C23.8157 19.5096 23.5267 19.2026 23.6028 18.8623V18.8546C23.6821 18.4896 23.7743 18.1255 23.8665 17.7615C24.0748 16.939 24.2831 16.1166 24.3428 15.2831C24.4569 13.6995 23.1719 12.5226 21.6513 12.5635C21.3497 12.5712 21.0379 12.8245 20.967 13.1213C20.9245 13.2986 20.8834 13.4761 20.8424 13.6536C20.7584 14.0165 20.6745 14.3791 20.5792 14.7382C20.0292 16.7951 19.0256 18.6141 17.733 20.2848C17.6851 20.3466 17.6373 20.4085 17.5895 20.4703C17.3291 20.8073 17.0698 21.1429 16.7978 21.4693C16.7091 21.5768 16.5647 21.7047 16.443 21.7047C15.6944 21.7185 14.9474 21.7171 14.1995 21.7157C13.9751 21.7153 13.7505 21.7149 13.5259 21.7149C12.393 21.7149 12.099 22.004 12.0838 23.1451C12.0744 23.9067 12.0653 24.6686 12.0562 25.4307C12.0383 26.9367 12.0203 28.4436 12.0001 29.9504C11.99 30.7563 12.5222 31.2705 13.318 31.2066ZM17.9586 30.1806C17.7001 30.1653 17.4973 29.9504 17.4973 29.6894L17.4999 29.6945C17.5016 29.2373 17.5055 28.7814 17.5094 28.3267C17.5221 26.8506 17.5346 25.387 17.4745 23.9279C17.4289 22.8355 17.7888 22.0424 18.4731 21.2339C20.0495 19.3663 21.114 17.2019 21.7704 14.8379C21.7767 14.8163 21.7857 14.7786 21.7974 14.7302C21.856 14.4863 21.9797 13.972 22.1404 13.8888C22.3593 13.7745 22.5183 13.8998 22.7017 14.0443L22.7056 14.0474C23.3519 14.5616 23.3062 15.278 23.1567 15.9918C23.0743 16.3833 22.9758 16.7731 22.8773 17.1628C22.6759 17.9599 22.4746 18.7565 22.4116 19.5659C22.3254 20.6634 22.6676 20.8783 23.6889 20.7504C24.9562 20.5918 26.2436 20.4946 27.5159 20.5457C28.5348 20.5867 28.8465 21.2979 28.4917 22.2752C28.4182 22.4722 28.4309 22.7843 28.5398 22.9532C29.0189 23.7028 28.9884 24.4089 28.5196 25.1432C28.4334 25.2788 28.4207 25.509 28.4613 25.6727C28.659 26.4479 28.5018 27.1029 27.924 27.6606C27.8125 27.7681 27.6756 27.9446 27.6908 28.0751C27.8758 29.7713 26.6314 30.3239 25.3515 30.3674C23.8768 30.4171 22.3981 30.3582 20.9193 30.2994C20.3421 30.2764 19.7648 30.2534 19.1878 30.2369C18.7874 30.2241 18.3894 30.2037 17.9586 30.1806ZM16.2402 23.3369V29.779C16.2402 30.0476 16.0248 30.2676 15.7562 30.2676H13.4296C13.1634 30.2676 12.9455 30.0502 12.9455 29.779V23.3369C12.9455 23.0683 13.1609 22.8483 13.4296 22.8483H15.7562C16.0223 22.8483 16.2402 23.0657 16.2402 23.3369Z" fill="white"/>
    </svg>      
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { mapGetters } from "vuex";
import { getDatabase, ref, onValue } from "firebase/database";
import FirebaseActions from "@/mixins/FirebaseActions";
import Redirection from "@/mixins/redirection.js";
import { _projectName } from "@/provider-config.js";

export default {
  props: {
    content: {
      type: Object,
    },
    likeFireCount: {
      type: Number,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    svgWnH: {
      type: Number
    }
  },
  data() {
    return {
      liked: false,
      likedColor: 'green',
      thumbSelectedColor:"#ffffff",
      noColor: "#FFFFFF",
      likeBlackColor: "black",
      thumbColor:"#ffffff",
      currentState: null,
      likeCount: 0,
      contentLikeCount: null,
      dislikeCountDisplay: null,
      applyColor: "clr-red",
      defaultColor: "like",
      defaultThemeColor : '',
    };
  },
  watch: {
  
    contentLikeCount(val) {
      // console.log("contentLikeCount", val);
      this.$emit("likeCount", val);
      // eventBus.$emit("like-count-to-mixin", val);
    },
    likeFireCount(val) {
      
    },
    content(val) {
      // console.log("watch content in like", val);
      this.fetchButtonState();
      this.getContentLikeCount();
      this.getContentDislikeCount();
    },
    subscriberid(val) {
      if (val) {
        this.fetchButtonState();
      }
    },
  },
  computed: {
    ...mapGetters(["subscriberid", "profileid"]),
  },
  mounted() {
    // document.getElementById(`Component_8_1${this.content.objectid}`)[0].addEventListener("mouseover", () => {
    //   document.getElementById(`Path_18${this.content.objectid}`)[0].setAttribute("fill", "white")
    // });

    // document.getElementById(`Component_8_1${this.content.objectid}`)[0].addEventListener("mouseout", () => {
    //   if (!this.liked)
    //   document.getElementById(`Path_18${this.content.objectid}`)[0].setAttribute("fill", "#ffffff")
    // })


    this.getContentLikeCount();
    this.getContentDislikeCount();
    eventBus.$on("updatelikeDislikeStatus", () => {
      console.log("logged In from like no subscriber Button");
    });
    
    this.defaultThemeColor = localStorage.getItem('theme') ? localStorage.getItem('theme') : 'theme-dark';
    if (this.defaultThemeColor === 'theme-dark') {
      this.isThemeDark = true;
      this.likedColor = "green";
    } else {
      this.isThemeDark = false;
      this.likedColor = "green";
    }
  },
  created() {
  this.fetchButtonState();

  eventBus.$on('theme-change', (data) => {
    if (data === 'theme-dark') {
      this.isThemeDark = true;
      this.likedColor = "#FECA35"; 
    } else {
      this.isThemeDark = false;
      this.likedColor = "#D0292A";
    }
  });
},

  methods: {
    fetchButtonState() {
      if (!this.content) return;

      const content = this.content;
      const db = getDatabase();
      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

      if ("seriesid" in content && content.seriesid) {
        path += `${content.objectid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }

      const contentRef = ref(db, path);

      onValue(contentRef, (snapshot) => {
        const response = snapshot.val();

        if (response?.likestatus === "LIKE") {
          this.liked = true;
          this.action = "REMOVE";
          this.currentState = "";
        } else if (response?.likestatus === "DISLIKE") {
          this.liked = false;
          this.action = "ADD";
          console.log("current state from like", response.likestatus);
          this.currentState = "DISLIKE";
        } else {
          this.liked = false;
          this.action = "ADD";
          this.currentState = "";
        }

        // console.log("action in likebtn", this.action);
      }, (error) => {
        console.error("Error fetching button state:", error);
      });
    },
    getContentLikeCount() {
      let payload = {
        objectid: this.content.objectid,
        type: "like",
      };
      this.fetchLikeDislikeCount(payload).then((result) => {
        if (result) {
          this.contentLikeCount = result;
        } else {
          this.contentLikeCount = 0;
        }
        // this.$emit("likeCount", this.contentLikeCount);
        // eventBus.$emit("like-count-to-mixin", this.contentLikeCount);
      });
    },
    getContentDislikeCount() {
      let payload = {
        objectid: this.content.objectid,
        type: "dislike",
      };
      this.fetchLikeDislikeCount(payload).then((result) => {
        if (result) {
          this.dislikeCountDisplay = result;
        } else {
          this.dislikeCountDisplay = 0;
        }
        // console.log("dislikeCount", this.dislikeCountDisplay);
        // this.$emit("dislikeCount", this.dislikeCountDisplay);
        // eventBus.$emit("dislike-count-to-mixin", this.dislikeCountDisplay);
      });
    },
    toggleActivity() {

      if (this.subscriberid) {
        // this.$emit("updateLikeCount", this.action);
        if (this.action === "ADD" && this.currentState === "") {
          // console.log("add");
          // this.updateContentCount(this.content, this.contentLikeCount, "LIKE");
          this.updateLikeDislikeToFire(this.content, "LIKE");
          //calculate counts
          this.contentLikeCount = this.contentLikeCount + 1;
          this.$emit("likeCount", this.contentLikeCount);
        } else if (this.action === "ADD" && this.currentState === "DISLIKE") {

          // when the content is DISLIKE change the status and count
          console.log("dislikeCountDisplay", this.dislikeCountDisplay);
          this.updateContentCount(
            this.content,
            this.contentLikeCount,
            "LIKE",
            this.dislikeCountDisplay
          );
          this.updateLikeDislikeToFire(this.content, "LIKE");
          this.contentLikeCount = this.contentLikeCount + 1;
          // this.dislikeCountDisplay =
          //   this.dislikeCountDisplay > 0 ? this.dislikeCountDisplay - 1 : 0;
          this.$emit("likeCount", this.contentLikeCount);
          this.$emit("dislikeCount", this.dislikeCountDisplay);
        } else if (this.action === "REMOVE") {

          // console.log("remove");
          this.updateContentCount(
            this.content,
            this.contentLikeCount,
            "REMOVELIKE"
          );
          this.updateLikeDislikeToFire(this.content, "NONE");

          //calculate counts
          this.contentLikeCount =
            this.contentLikeCount > 0 ? this.contentLikeCount - 1 : 0;
          this.$emit("likeCount", this.contentLikeCount);
        }
      } else {          
          let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
          localDisplayLang = localDisplayLang == 'eng' ? 'en' : localDisplayLang;
          this.redirectToLogin(localDisplayLang);
        // let payload = {
        //   state: true,
        //   formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
      }
    },
  },
  mixins: [FirebaseActions, Redirection],
};
</script>

<style lang="scss">
@import "./LikeBtn.scss";
@import "@/sass/_variables.scss";

.iconouterfill{
  fill:$like-icon-outerfill
}

@media only screen and (min-width: 1000px) {
    .Component_8_1:hover g { 
      fill:$clr-likebutton-hover;
  }
}

.pointer {
  cursor: pointer;
}
</style>
